export enum EntityTypeEnum {
  Promotion = 'promotion',
  Campaign = 'campaign',
}
